import React, { useEffect } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ShowcaseModal = ({ item, onClose, onCreate }) => {
  useEffect(() => {
    if (!item) return undefined;
    const onKey = (e) => e.key === 'Escape' && onClose();
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.removeEventListener('keydown', onKey); document.body.style.overflow = prev; };
  }, [item, onClose]);

  if (!item) return null;
  return (
    <div className="corp-modal-backdrop" onClick={onClose} data-testid="showcase-modal" role="dialog" aria-modal="true">
      <div className="corp-modal" onClick={(e) => e.stopPropagation()}>
        <button className="corp-modal-close" onClick={onClose} aria-label="Close" data-testid="showcase-modal-close">×</button>
        <div className="corp-modal-img">
          <img src={`${BACKEND_URL}${item.bottleUrl}`} alt={`${item.name} custom wine`} />
        </div>
        <div className="corp-modal-body">
          <p className="corp-bottle-cat">{item.subcategoryLabel}</p>
          <h3 className="ff-serif" data-testid="showcase-modal-name">{item.name}</h3>
          {item.useCase && <p className="corp-modal-use">{item.useCase}</p>}
          {item.description && <p className="corp-modal-desc">{item.description}</p>}
          {item.link && (
            <a href={item.link} target="_blank" rel="noreferrer" className="corp-modal-link" data-testid="showcase-modal-link">
              Visit {item.name} →
            </a>
          )}
          <div className="corp-modal-cta">
            <p>Want something like this?</p>
            <button className="ff-btn ff-btn-primary" onClick={onCreate} data-testid="showcase-modal-create">
              Create Your Wine
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShowcaseModal;
